export default __webpack_public_path__ + "ef5305d0bc3dba75dab04ab4ccc4c76e.jpg";